module.exports = __webpack_public_path__ + "img/FI22319362.1f93c563.svg";